module.exports = __webpack_public_path__ + "img/global-1991-japan.e4632fba.jpg";